import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

import { NotFound } from 'src/pages/404/404'

const PACKAGE_TIERS = ['kakano', 'tipu', 'rakau', 'ngahere'] as const
type PackageTier = (typeof PACKAGE_TIERS)[number]

// Each tier has its own Sanity content page. Editors author them independently
// — no shared template, no per-tier hero discriminator needed.
const TIER_TO_SANITY_SLUG: Record<PackageTier, string> = {
  kakano: 'kakano',
  tipu: 'tipu',
  rakau: 'rakau',
  ngahere: 'ngahere'
}

const isValidTier = (value: string | undefined): value is PackageTier =>
  PACKAGE_TIERS.includes(value as PackageTier)

const PackageDetailPage: NextPage = () => {
  const router = useRouter()

  if (!router.isReady) return null

  const { tier } = router.query as { tier?: string }

  if (!isValidTier(tier)) return <NotFound />

  return (
    <SanityContentPage
      slug={TIER_TO_SANITY_SLUG[tier]}
      showBreadcrumbs={false}
    />
  )
}

export default PackageDetailPage
